export enum LoadState {
  idle,
  loading,
  loaded,
}

export enum ModalKeys {
  closeAccountModal = 'closeAccountModal',
}

export enum ErrorTypes {
  doNoMatch = 'DoNoMatch',
  badCredentialsException = 'BadCredentialsException',
  nicknameDuplicatedException = 'NicknameDuplicatedException',
}

export enum ControlName {
  subscribedNewsletter = 'subscribedNewsletter',
  nickname = 'nickname',
  language = 'language',
  btcLnUnit = 'btcLnUnit',
  appearance = 'appearance',
  dateFormat = 'dateFormat',
  numberFormat = 'numberFormat',
  timeFormat12Hour = 'timeFormat12Hour',
  timezone = 'timezone',
}
